import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { BuyButton } from './ui/BuyButton';
import { BRAND, offerIncludes, CHECKOUT_URL } from '../data/site';
import { usePricing } from '../hooks/usePricing';
interface OfferCardProps {
  showCountdown: boolean;
  countdown: {
    hours: string;
    minutes: string;
    seconds: string;
  };
}
export function OfferCard({
  showCountdown,
  countdown
}: OfferCardProps) {
  const pricing = usePricing();
  const timeUnits = [{
    value: countdown.hours,
    label: 'Hours'
  }, {
    value: countdown.minutes,
    label: 'Min'
  }, {
    value: countdown.seconds,
    label: 'Sec'
  }];
  return <section id="oferta" className="w-full bg-sage-800 px-5 py-16 sm:px-8 lg:py-28" aria-labelledby="oferta-titulo" data-id="element-115" data-mp="1af10zlmuils2">
      <div className="mx-auto max-w-3xl text-center" data-id="element-116" data-mp="15evcgebvhfe7">
        <p className="flex items-center justify-center gap-3 text-[11px] font-semibold uppercase tracking-overline text-gold-200" data-id="element-117" data-mp="22xeyfk49s5qm">
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-118" data-mp="1y4c0z0wdgc55" />
          Your access
          <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-119" data-mp="8gl0w50dtxm9" />
        </p>
        <h2 className="mt-5 font-serif text-[2.2rem] leading-[1.06] text-cream sm:text-[3rem]" data-id="element-120" data-mp="ddkzxvyte03v">
          Skip the <strong className="font-semibold" data-id="element-121" data-mp="3vsdmdlmj0t48">mistakes, wasted supplies</strong>{' '}
          and guesswork with a{' '}
          <span className="italic text-gold-200" data-id="element-122" data-mp="3n00657empjd">method that works</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[16px] leading-relaxed text-sage-100" data-id="element-123" data-mp="3ltecjzq0yrfn">
          This isn't a loose ebook. It's the complete method — projects, resources and
          practical know-how — so every flower you press actually becomes a finished
          piece.
        </p>
      </div>

      <div className="mx-auto mt-12 max-w-xl" data-id="element-124" data-mp="3gvwckytzjmjs">
        {showCountdown ? <div className="flex justify-center gap-3" data-editable="countdown-placeholder" data-id="element-125" data-mp="1b3zf7jie2z7x">
            {timeUnits.map(unit => <div key={unit.label} className="w-20 rounded-2xl border border-sage-700 bg-sage-900/60 py-3 text-center" data-id="element-126" data-mp="2o1puixaeyhe1">
                <p className="font-serif text-2xl text-cream" data-id="element-127" data-mp="2j4g8zsq5apvh">{unit.value}</p>
                <p className="mt-0.5 text-[10px] uppercase tracking-[0.16em] text-sage-200" data-id="element-128" data-mp="2f0s096ps1o8n">
                  {unit.label}
                </p>
              </div>)}
          </div> : null}

        <div className="mt-7 overflow-hidden rounded-4xl bg-cream shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)]" data-id="element-129" data-mp="36tseahicqdsi">
          <div className="border-b border-gold-200/70 bg-bone px-6 py-6 text-center" data-id="element-130" data-mp="32sgn47jtxki7">
            <p className="text-[11px] font-semibold uppercase tracking-overline text-terracotta-500" data-id="element-131" data-mp="2xx9ohe5f3605">
              Limited time offer
            </p>
            <h3 id="oferta-titulo" className="mt-3 font-serif text-[2rem] leading-none text-sage-800" data-id="element-132" data-mp="3qfx2k9lzxkrq">
              {BRAND.product}
            </h3>
            <p className="mt-2 text-[13px] text-ink-light" data-id="element-133" data-mp="3t0mo1wwclxls">{BRAND.subtitle}</p>
          </div>

          <div className="px-6 py-8 sm:px-10" data-id="element-134" data-mp="1ta6vhvgtk5v">
            <div className="mb-8 w-full rounded-3xl border-2 border-gold-200/60 bg-bone px-6 py-8 text-center shadow-inner" data-id="element-135" data-mp="1u24szcjbtzb">
              <p className="text-[12px] font-bold uppercase tracking-[0.2em] text-terracotta-600" data-id="element-136" data-mp="6v99gpjdsd1r">
                Special Price
              </p>
              
              <div className="mt-3 flex items-center justify-center gap-3 text-ink-light" data-id="element-137" data-mp="ft1tg701s8vh">
                <span className="text-[14px] font-medium uppercase tracking-wider" data-id="element-138" data-mp="krd1cc6s89b2">Regular price:</span>
                <span className="text-[18px] font-bold line-through decoration-terracotta-500/80 decoration-[3px]" data-id="element-139" data-mp="pkpgzwthh5ro">
                  {pricing.currency} {pricing.anchor}
                </span>
              </div>
              
              <div className="mt-2 flex items-baseline justify-center gap-2" data-id="element-140" data-mp="yhzs9i6awuwl">
                <span className="text-2xl font-bold text-sage-800" data-id="element-141" data-mp="13jp06oy88sgg">{pricing.currency}</span>
                <span className={`font-serif text-[4rem] leading-none text-sage-900 transition-opacity duration-300 sm:text-[5rem] ${pricing.loading ? 'opacity-40' : 'opacity-100'}`} data-id="element-142" data-mp="puvraywaqbwh">
                  {pricing.loading ? '···' : pricing.price}
                </span>
              </div>
              
              <p className="mt-4 inline-block rounded-full bg-gold-200/50 px-4 py-1.5 text-[11.5px] font-bold uppercase tracking-wider text-sage-900" data-id="element-143" data-mp="6wsysa4jhwtx">
                One-time payment · Lifetime access
              </p>
            </div>

            <ul className="space-y-3 border-b border-gold-200/70 pb-7" data-id="element-144" data-mp="gx1xpvpx1wd0">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-145" data-mp="bz0dh7gr7qzy">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-sage-700" data-id="element-146" data-mp="1s9chjcmomi5b">
                    <CheckIcon className="h-3 w-3 text-cream" aria-hidden="true" data-id="element-147" data-mp="1ndx8cxzmdaf8" />
                  </span>
                  <span className="text-[15px] leading-snug text-sage-800" data-id="element-148" data-mp="35bseovq6h5pt">
                    {item}
                  </span>
                </li>)}
            </ul>

            <BuyButton size="xl" label="Get Instant Access" href={CHECKOUT_URL} className="mt-7 w-full" data-id="element-149" data-mp="2walyknrfxwx3" />

            <p className="mt-4 flex items-center justify-center gap-1.5 text-[11.5px] text-ink-light" data-id="element-150" data-mp="3oyq1j1imnvw3">
              <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-151" data-mp="3sxqlwogr76l7" />
              Secure checkout · Download link emailed instantly
            </p>
          </div>
        </div>
      </div>
    </section>;
}